import AppSignalR from '@/signalr/App.signalr';
import signalrClientMethod from './names/Signalr.clientMethod';

class Broadcast {

	static onAddOrUpdate (listener: (broadcastModel: IBroadcastModel) => void) {
		return AppSignalR.on(signalrClientMethod.BroadcastAddOrUpdate, listener);
	}

	static offAddOrUpdate (listener: (broadcastModel: IBroadcastModel) => void) {
		return AppSignalR.off(signalrClientMethod.BroadcastAddOrUpdate, listener);
	}

	static onDelete (listener: (id: number) => void) {
		return AppSignalR.on(signalrClientMethod.BroadcastDelete, listener);
	}

	static offDelete (listener: (id: number) => void) {
		return AppSignalR.off(signalrClientMethod.BroadcastDelete, listener);
	}

}

export default Broadcast;
